import { calculateNextFormValue } from '../../utils/calculate-next-form-value';
/**
 * Sets new field value after intialization. Used for handling e.g. real-time refresh in the Issue View.
 *
 * Warning:
 * - If you want to handle the UI modification onChange, use `processChange` action instead.
 * - If you want to initialize the field, use `initializeField` action instead.
 */
export var setFieldValue = function setFieldValue(_ref) {
  var fieldId = _ref.fieldId,
    fieldType = _ref.fieldType,
    fieldValue = _ref.fieldValue;
  return function (_ref2, _ref3) {
    var getState = _ref2.getState,
      setState = _ref2.setState;
    var viewType = _ref3.viewType;
    var _getState = getState(),
      internalFormMetadata = _getState.internalFormMetadata,
      formData = _getState.formData;

    /**
     * We can set new field value only if the field was initialized.
     * This checks the field metedata that indicates the successfull initialization.
     */
    if (!internalFormMetadata[fieldId]) {
      return;
    }
    var nextFormData = calculateNextFormValue({
      internalFormMetadata: internalFormMetadata,
      formData: formData,
      fieldType: fieldType,
      fieldId: fieldId,
      fieldValue: fieldValue,
      viewType: viewType
    });
    if (nextFormData === null) {
      return;
    }
    setState({
      formData: nextFormData
    });
  };
};